// 发票填写页埋点配置
const config = {
  // 发票填写页
  'Invoice.invoice.type': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '选择发票类型（不开/电子）',
    c: {
      type: 'variable',
      func: ({ text }) => {
        return text === '个人' || text === '企业' ? 'mode' : 'type';
      },
    },
    d: {
      type: 'variable',
      func: ({ index }) => index || 1,
    },
    iid: {
      type: 'variable',
      func: ({ text }) => {
        let type = null;
        switch (text) {
          case '电子发票':
            type = 1;
            break;
          case '不开发票':
            type = 0;
            break;
          case '个人':
            type = 0;
            break;
          case '企业':
            type = 1;
            break;
          default:
            break;
        }
        return `type=${type}`;
      },
    },
  },
  // 发票titleList
  'Invoice.invoice.input': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '发票titleList',
    c: {
      type: 'variable',
      func: ({ label }) => {
        return label === '个人名称' ? 'header' : 'header';
      },
    },
    d: {
      type: 'constant',
      value: 1,
    },
  },
  // 发票查看更多
  'Invoice.invoice.expandmore': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '发票titleList',
    c: {
      type: 'constant',
      value: 'expandmore',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: ({ isCollapse }) => {
        return `status=${isCollapse ? '0' : '1'}`;
      },
    },
  },
  // 发票常见问题
  'Invoice.invoice_invoice_qa': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '发票常见问题',
    c: {
      type: 'constant',
      value: 'invoice_qa',
    },
    d: {
      type: 'constant',
      value: 1,
    },
    iid: {
      type: 'variable',
      func: ({ url }) => {
        return `u=${url}`;
      },
    },
  },
  // 发票提交按钮
  'Invoice.invoice.submit': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '发票提交',
    c: {
      type: 'constant',
      value: 'done',
    },
    d: {
      type: 'constant',
      value: 1,
    },
  },
  // 发票title列表弹窗关闭按钮
  'Invoice.title.list.close': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '发票抬头列表弹窗关闭',
    c: {
      type: 'variable',
      func: ({ invoiceType }) => {
        return invoiceType === 'person' ? 'closepersonalinvoice_list' : 'closecorporateinvoice_list';
      },
    },
    d: {
      type: 'constant',
      value: 1,
    },
  },
  // 发票title列表点击
  'Invoice.title.list.click': {
    operation: ['TOUCH'],
    title: '发票抬头列表点击',
    c: {
      type: 'variable',
      func: ({ invoiceType }) => {
        return invoiceType === 'person' ? 'person_header' : 'company_header';
      },
    },
    d: {
      type: 'variable',
      func: ({ d }) => d,
    },
  },
  // 发票title列表添加
  'Invoice.invoicelist.add': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '发票抬头列表添加发票',
    c: {
      type: 'variable',
      func: ({ invoiceType }) => {
        return invoiceType === 'person' ? 'person_upsert' : 'company_upsert';
      },
    },
    d: {
      type: 'constant',
      value: 1,
    },
    iid: {
      type: 'variable',
      func: ({ url }) => {
        return `u=${url}`;
      },
    },
  },
  // 发票title列表编辑
  'Invoice.invoicelist.edit': {
    operation: ['TOUCH'],
    title: '发票title列表编辑',
    c: {
      type: 'variable',
      func: ({ invoiceType }) => {
        return invoiceType === 'person' ? 'person_update' : 'company_update';
      },
    },
    d: {
      type: 'variable',
      func: ({ d }) => d,
    },
    iid: {
      type: 'variable',
      func: ({ url }) => {
        return `u=${url}`;
      },
    },
  },
  'Invoice.title.list': {
    operation: ['VISIBLE'],
    title: '发票title列表',
    // 发票
    getParse: {
      type: 'variable',
      func: function (item = {}, visibleData, args) {
        const { pageName, traceObj } = args;
        const result = [
          {
            type: 'invoice',
            item: item.item,
            isViewable: item.isViewable,
            key: item.key,
            index: item.index,
            page: pageName,
            b: pageName,
            c: traceObj.flow === 'person' ? 'person_header' : 'company_header',
            d: item.index + 1,
          },
          {
            type: 'invoice',
            item: item.item,
            isViewable: item.isViewable,
            key: item.key,
            index: item.index,
            page: pageName,
            b: pageName,
            c: traceObj.flow === 'person' ? 'person_update' : 'company_update',
            d: item.index + 1,
          },
        ];
        return result;
      },
    },
  },
};
export default config;
